export enum EntityStatus{
    "deleted",
    "draft",
    "created"
}